/* PATOYS predictive search: dependency-free, keyboard + touch friendly. */
(function () {
  const panel = document.querySelector('[data-pt-search-panel]');
  const input = document.getElementById('PtSearch');
  if (!panel || !input) return;
  const form = input.closest('form');
  const sheetInput = panel.querySelector('.pt-ss__input');
  const emptyEl = panel.querySelector('[data-ss-empty]');
  const resultsEl = panel.querySelector('[data-ss-results]');
  const noneEl = panel.querySelector('[data-ss-none]');
  const noneText = panel.querySelector('[data-ss-none-text]');
  const statusEl = panel.querySelector('[data-ss-status]');
  const d = panel.dataset;
  const mq = window.matchMedia('(max-width: 749px)');
  let timer = 0;
  let ctrl = null;
  let lastQ = '';
  let open = false;
  let active = -1;
  let optId = 0;

  const fmt = (function () {
    try {
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur, maximumFractionDigits: 0 });
    } catch (e) {
      return { format: function (n) { return '₹' + Math.round(n); } };
    }
  })();
  const tt = function (s, k, v) { return s.replace('__' + k + '__', v); };

  document.body.appendChild(panel);
  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-expanded', 'false');
  input.setAttribute('aria-controls', 'PtSearchPanel');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('autocomplete', 'off');

  const activeInput = function () { return mq.matches ? sheetInput : input; };
  const options = function () { return Array.prototype.slice.call(panel.querySelectorAll('[data-ss-results] a[data-opt]')); };

  function position() {
    if (mq.matches) {
      panel.style.top = '';
      panel.style.left = '';
      panel.style.width = '';
      return;
    }
    const r = form.getBoundingClientRect();
    panel.style.top = Math.round(r.bottom + 8) + 'px';
    panel.style.left = Math.round(r.left) + 'px';
    panel.style.width = Math.round(r.width) + 'px';
  }

  function show() {
    if (open) return;
    open = true;
    position();
    panel.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    if (mq.matches) {
      document.documentElement.classList.add('pt-ss-lock');
      sheetInput.value = input.value;
      sheetInput.focus();
    }
  }

  function hide(returnFocus) {
    if (!open) return;
    open = false;
    panel.hidden = true;
    active = -1;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    document.documentElement.classList.remove('pt-ss-lock');
    if (returnFocus && !mq.matches) input.focus({ preventScroll: true });
    if (mq.matches) input.blur();
  }

  function view(which) {
    emptyEl.hidden = which !== 'empty';
    resultsEl.hidden = which !== 'results';
    noneEl.hidden = which !== 'none';
  }

  function el(tag, cls, text) {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function group(title) {
    const g = el('div', 'pt-ss__group');
    g.appendChild(el('p', 'pt-ss__heading', title));
    return g;
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function opt(a) {
    optId += 1;
    a.setAttribute('data-opt', '');
    a.id = 'pt-opt-' + optId;
    a.setAttribute('role', 'option');
    return a;
  }

  function linkGroup(title, items, cls) {
    const g = group(title);
    const wrap = el('div', cls);
    items.forEach(function (c) {
      const a = opt(el('a', cls === 'pt-ss__chips' ? 'pt-ss__chip' : 'pt-ss__link', c.title || c.text));
      a.href = c.url;
      wrap.appendChild(a);
    });
    g.appendChild(wrap);
    return g;
  }

  function render(res, q) {
    resultsEl.textContent = '';
    optId = 0;
    const r = res.resources.results;
    const total = r.products.length + r.collections.length + r.pages.length;
    if (!total && !r.queries.length) {
      noneText.textContent = tt(d.tNoResults, 'terms', '“' + q + '”');
      statusEl.textContent = noneText.textContent;
      view('none');
      return;
    }
    const list = el('div');
    list.setAttribute('role', 'listbox');
    list.id = 'pt-ss-list';

    if (r.products.length) {
      const g = group(d.tProducts);
      r.products.forEach(function (p) {
        const a = opt(el('a', 'pt-ss__item'));
        a.href = p.url;
        const src = (p.featured_image && p.featured_image.url) || p.image;
        const img = el('img', 'pt-ss__img');
        img.alt = '';
        img.width = 56;
        img.height = 56;
        img.loading = 'lazy';
        img.decoding = 'async';
        if (src) img.src = sized(src, 120);
        a.appendChild(img);
        const meta = el('span', 'pt-ss__meta');
        meta.appendChild(el('span', 'pt-ss__name', p.title));
        const row = el('span', 'pt-ss__row');
        row.appendChild(el('span', 'pt-ss__price', fmt.format(parseFloat(p.price))));
        const cmp = parseFloat(p.compare_at_price_max);
        if (cmp && cmp > parseFloat(p.price)) row.appendChild(el('s', 'pt-ss__was', fmt.format(cmp)));
        row.appendChild(el('span', 'pt-ss__badge ' + (p.available ? 'is-in' : 'is-out'), p.available ? d.tInStock : d.tOutStock));
        meta.appendChild(row);
        a.appendChild(meta);
        g.appendChild(a);
      });
      list.appendChild(g);
    }
    if (r.collections.length) list.appendChild(linkGroup(d.tCollections, r.collections, 'pt-ss__links'));
    if (r.pages.length) list.appendChild(linkGroup(d.tPages, r.pages, 'pt-ss__links'));
    if (r.queries.length) list.appendChild(linkGroup(d.tSuggestions, r.queries.slice(0, 5), 'pt-ss__chips'));
    resultsEl.appendChild(list);

    const all = opt(el('a', 'pt-ss__all', tt(d.tViewAll, 'terms', '“' + q + '”')));
    all.href = d.searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
    resultsEl.appendChild(all);
    statusEl.textContent = tt(d.tCount, 'count', String(total));
    view('results');
  }

  function fetchResults(q) {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    const u = d.url + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page,query&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,tag,variants.title,vendor';
    statusEl.textContent = d.tLoading;
    fetch(u, { signal: ctrl.signal, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (j) { if (q === lastQ) render(j, q); })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        noneText.textContent = d.tError;
        view('none');
      });
  }

  function onInput(src) {
    const q = src.value.trim();
    if (src === input) sheetInput.value = src.value; else input.value = src.value;
    active = -1;
    input.removeAttribute('aria-activedescendant');
    clearTimeout(timer);
    if (q.length < 2) {
      lastQ = '';
      if (ctrl) ctrl.abort();
      statusEl.textContent = '';
      view('empty');
      return;
    }
    lastQ = q;
    timer = setTimeout(function () { fetchResults(q); }, 180);
  }

  function move(dir) {
    const o = options();
    if (!o.length) return;
    active = (active + dir + o.length) % o.length;
    o.forEach(function (n, i) { n.classList.toggle('is-active', i === active); });
    o[active].scrollIntoView({ block: 'nearest' });
    activeInput().setAttribute('aria-activedescendant', o[active].id);
  }

  function onKey(e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      show();
      move(1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      move(-1);
    } else if (e.key === 'Enter' && active > -1) {
      const o = options()[active];
      if (o) {
        e.preventDefault();
        window.location.href = o.href;
      }
    }
  }

  input.addEventListener('focus', show);
  input.addEventListener('click', show);
  input.addEventListener('input', function () { show(); onInput(input); });
  input.addEventListener('keydown', onKey);
  sheetInput.addEventListener('input', function () { onInput(sheetInput); });
  sheetInput.addEventListener('keydown', onKey);
  panel.querySelector('[data-ss-close]').addEventListener('click', function () { hide(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && open) { e.preventDefault(); hide(true); }
  });
  document.addEventListener('mousedown', function (e) {
    if (!open || mq.matches) return;
    if (!panel.contains(e.target) && !form.contains(e.target)) hide(false);
  });
  window.addEventListener('scroll', function () { if (open && !mq.matches) position(); }, { passive: true });
  window.addEventListener('resize', function () {
    if (!open) return;
    document.documentElement.classList.toggle('pt-ss-lock', mq.matches);
    position();
  });
})();
